<template>
  <v-container>
    <v-card>
      <v-card-title class="headline" style="margin-bottom:10px">Clock Out</v-card-title>
    </v-card>
    <v-card></v-card>
      <v-card>
        <v-dialog v-model="completeDialog" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">Clock Out Successful</v-card-title>
            <v-card-text>You have successfully managed to clock out. Do you have any expenses to claim for this shift?</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" flat to="/">No</v-btn>
              <v-btn color="green darken-1" flat :to="'/Expenses/'+this.shiftID">Yes</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="errorDialog" persistent>
          <v-card>
            <v-card-title class="headline">Offline</v-card-title>
            <v-card-text>
              <v-alert v-model="errorDialog" icon="cloud_off" type="error">You are currently offline, Please try again later</v-alert>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" flat to="/">OK</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-container>
          <v-form v-model="formValid" ref="form" lazy-validation>
            <v-dialog
              ref="dateDialog"
              persistent
              v-model="dateDialog"
              lazy
              full-width
              :return-value.sync="date"
              width="290px"
              :disabled="disableTimeChangeOut"
            >
              <v-text-field
                slot="activator"
                label="End Date"
                v-model="formatDate"
                prepend-icon="event"
                readonly
                :rules="timeRules"
                :disabled="disableTimeChangeOut"
              ></v-text-field>
              <v-date-picker v-model="date" actions full-width :min="latestJobEndDate">
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="dateDialog = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.dateDialog.save(date)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
            <v-dialog
              ref="timeDialog"
              persistent
              v-model="timeDialog"
              lazy
              full-width
              width="fit-content"
              :return-value.sync="time"
              :disabled="disableTimeChangeOut"
            >
              <v-text-field
                slot="activator"
                label="End Time"
                v-model="timeFormat"
                prepend-icon="access_time"
                readonly
                :rules="timeRules"
                :disabled="disableTimeChangeOut"
              ></v-text-field>
              <b-timepicker
                inline
                size="is-large"
                placeholder="Click to select..."
                icon="clock"
                v-model="time"
                :time-parser="formatTimeStringToDate"
                :time-format="formatTimeDateToString"
                :min-time="minEndTime"
                hour-format="24">
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="timeDialog = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.timeDialog.save(time)">OK</v-btn>
            </b-timepicker>
            </v-dialog>
            <span v-if="applicationMode === 'tacho' && spanMidnight" class="warning--text"><v-icon class="mr-3" color="warning">warning</v-icon>Shifts spanning midnight are unable to be added as tachograph days</span>
            <v-text-field
              v-if="nightOutRefType !== 'off' && nightOutRefType !== 'yes/no'"
              label="Night Out Reference"
              v-model="nightOut"
              prepend-icon="hotel"
              :type="nightOutRefType"
              :rules="nightOutRules"
            ></v-text-field>
            <v-select
              label="Night Out"
              prepend-icon="hotel"
              v-if="nightOutRefType === 'yes/no'"
              v-model="nightOut"
              :items="[
                {value: '1', text: 'Yes'},
                {value: '', text: 'No'},
              ]"
            />
            <v-text-field
              v-if="has_bonus"
              label="Drops/Collections Total"
              v-model="bonus"
              type="number"
            ></v-text-field>
            <v-textarea
              label="Notes"
              v-model="notes"
              maxlength="255"
            />
            <v-btn class="primary" :loading="loading" block @click="clockOut" :disabled="!formValid">Confirm End</v-btn>
          </v-form>
          <h1>{{ gpsStatus }}</h1>

          <v-dialog
            v-model="tachoDayPrompt"
            persistent
            max-width="450">
            <v-card>
              <v-card-title>Tachograph Day</v-card-title>
              <v-card-text>Would you like to add this shift as a tachograph day?</v-card-text>
              <v-card-actions>
              <v-spacer></v-spacer>
            <v-btn
              flat
              dark
              color="error"
              :disabled="addingTachoDay"
              @click="tachoDayPrompt = false;submitClockOut()">
              No
            </v-btn>
            <v-btn
              flat
              dark
              color="success"
              :loading="addingTachoDay"
              @click="addTachoDay">
              Yes
            </v-btn>
            </v-card-actions>
            </v-card>  
          </v-dialog>

          <v-snackbar
            v-model="tachoService.snackbar"
            :color="tachoService.status === 1 ? 'success' : 'error'"
            multi-line
            :timeout="tachoService.status === 1 ? 8000 : 0">
            {{ tachoService.msg }}
            <v-btn
              dark
              v-if="tachoService.closeable"
              flat
              @click="tachoService.snackbar = false">
              Close
            </v-btn>
          </v-snackbar>
        </v-container>
      </v-card>
      </v-container>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import dbPromise from '../dbPromise'

export default {
  data () {
    return {
      url: this.$store.getters.url,
      dateDialog: false,
      date: null,
      timeDialog: false,
      time: null,
      timeFormat: null,
      nightOut: '',
      bonus: null,
      completeDialog: false,
      empID: this.$store.getters.user.empID,
      has_bonus: this.$store.getters.user.has_bonus,
      company: this.$store.getters.company,
      disableTimeChangeOut: this.$store.getters.disableTimeChangeOut,
      notes: '',
      loading: false,
      errorDialog: false,
      shiftID: null,
      nightOutRules: [
        v => (v.length < 19) || 'Maximum length exceeded'
      ],
      formValid: true,
      gps: null,
      tachoService: {
        snackbar: false,
        status: 0,
        msg: '',
        closeable: true
      },
      tachoDayPrompt: false,
      addingTachoDay: false,
      postObj: {
        emp: this.empID,
        company: this.company,
        type: 'out',
        tacho: null,
        data: {
          end: null,
          nightOut: null,
          gps: null
        }
      },
      clockOutLimit: this.$store.getters.clockOutLimit,
      nightOutRefType: this.$store.getters.nightOutRefType,
      gpsStatus: '',
      gpsAttemptComplete: false,
      latestJobEndTime: null,
      latestJobEndDate: null,
      latestJobEndTimeDateObj: null,
      minEndTime: moment().toDate()
    }
  },
  created () {
    let timesheetData = [...this.$store.getters.timesheet]
    this.notes = timesheetData[timesheetData.length - 1].notes || ''
    this.latestJobEndTime = sessionStorage.getItem('latestJobEndTime')
    this.latestJobEndTimeDateObj = this.latestJobEndTime ? moment(this.latestJobEndTime).toDate() : null
    this.latestJobEndDate = this.latestJobEndTime ? moment(this.latestJobEndTime).format('YYYY-MM-DD') : null

    this.date = this.latestJobEndTime ? this.latestJobEndDate : moment().format('YYYY-MM-DD')
    this.time = this.latestJobEndTime ? this.latestJobEndTimeDateObj : moment().toDate()
  },
  watch: {
    time: function (value) {
      this.timeFormat = moment(new Date(value)).format('HH:mm')
      this.$refs.form.validate()
    },
    date: function (value) {
      this.$refs.form.validate()
      console.log('date changed')
      console.log(value)
      if (this.latestJobEndTimeDateObj && moment(value).isSame(moment(this.latestJobEndTime), 'day')) {
        this.minEndTime = this.latestJobEndTimeDateObj
      } else {
        this.minEndTime = moment().startOf('day').toDate()
      }
    }
  },
  mounted: function () {
    if (localStorage.getItem('lat') && localStorage.getItem('long')) {
      this.gps = localStorage.getItem('lat') + ' ' + localStorage.getItem('long')
      this.gpsAttemptComplete = true
      this.gpsStatus = 'Using Static Machine GPS'
    } else if (navigator.geolocation) {
      this.gpsStatus = 'Getting GPS'
      navigator.geolocation.getCurrentPosition(position => {
        this.gps = position.coords.latitude + ' ' + position.coords.longitude
        this.gpsStatus = 'GPS Acquired'
        this.gpsAttemptComplete = true
      }, error => {
        this.gpsAttemptComplete = true
        this.gpsStatus = 'GPS Error'
        console.log(error)
      }, {
        enableHighAccuracy: false,
        timeout: 5000,
        maximumAge: 0
      })
    } else {
      this.gpsAttemptComplete = true
      this.gpsStatus = 'GPS not available on this machine.'
    }
    this.$store.dispatch('checkLoginTime')
  },
  computed: {
    formatDate () {
      return moment(this.date).format('DD/MM/YYYY')
    },
    maxEndTime () {
      return moment().add(30, 'minutes').toDate()
    },
    applicationMode () {
      return this.$store.getters.applicationMode
    },
    user () {
      return this.$store.getters.user
    },
    clockInDate () {
      let timesheetData = [...this.$store.getters.timesheet]
      return timesheetData[timesheetData.length - 1].start
    },
    spanMidnight () {
      const clockIn = moment(this.clockInDate, 'YYYY-MM-DD HH:mm:ss.SSS')
      const clockOut = moment(this.date + ' ' + this.timeFormat, 'YYYY-MM-DD HH:mm')
      return !clockIn.isSame(clockOut, 'day')
    },
    timeRules () {
      let arr = [v => (moment(this.date + ' ' + this.timeFormat, 'YYYY-MM-DD HH:mm').isAfter(moment(this.clockInDate, 'YYYY-MM-DD HH:mm:ss.SSS'))) || 'Clocking out time must be after clocking in time']
      if (this.clockOutLimit > -1) {
        arr.push(v => (moment(this.date + ' ' + this.timeFormat, 'YYYY-MM-DD HH:mm').isSameOrBefore(moment().add(this.clockOutLimit, 'minutes'), 'minute')) || 'Clocking out in the future is not allowed')
      }
      return arr
    }
  },
  methods: {
    clockOut () {
      if (this.applicationMode === 'tacho' && this.spanMidnight === false) {
        this.tachoDayPrompt = true
      } else {
        this.postObj.tacho = null
        this.submitClockOut()
      }
    },
    addTachoDay () {
      this.addingTachoDay = true
      let end = this.date + ' ' + moment(this.timeFormat, 'HH:mm').format('HH:mm')
      const tachoObj = {
        username: 'tanda.' + this.company,
        emp_id: this.user.empID.toString(),
        shift_start: this.clockInDate,
        shift_end: end + ':00.000'
      }
      console.log(tachoObj)
      // axios.post(this.url + '/cwelite_utilities/cwelite_utilities.svc/AddTachoDayToLegacy', {
      axios.post(this.url + '/cwelite_utilities/cwelite_utilities.svc/AddTachoDayToLegacy', tachoObj)
        .then(serviceResponse => {
          this.tachoDayPrompt = false
          console.log(serviceResponse)
          if (serviceResponse.data.ExceptionMessage.length === 0) {
            this.tachoService.snackbar = true
            this.tachoService.status = 1
            this.tachoService.closeable = true
            this.tachoService.msg = 'Tachograph day successfully added'
            this.postObj.tacho = 1
          } else if (serviceResponse.data.emp_id === -1) {
            this.tachoService.snackbar = true
            this.tachoService.status = 2
            this.tachoService.closeable = true
            this.tachoService.msg = 'Error adding Tachograph day: Employee not found.'
            this.postObj.tacho = 0
          } else {
            this.tachoService.snackbar = true
            this.tachoService.status = 2
            this.tachoService.closeable = true
            this.tachoService.msg = 'Error adding Tachograph day: ' + serviceResponse.data.ExceptionMessage
            this.postObj.tacho = 0
          }
          this.addingTachoDay = false
          this.submitClockOut()
        })
        .catch(error => {
          this.tachoDayPrompt = false
          console.log(error)
          this.addingTachoDay = false
          this.tachoService.snackbar = true
          this.tachoService.status = 2
          this.tachoService.closeable = false
          this.tachoService.msg = 'Error adding Tachograph day'
          this.postObj.tacho = 0
          this.submitClockOut()
        })
    },
    submitClockOut () {
      if (this.$refs.form.validate()) {
        this.loading = true
        let end = this.date + ' ' + moment(this.timeFormat, 'HH:mm').format('HH:mm')
        if (this.latestJobEndTime != null && moment(end).isBefore(moment(this.latestJobEndTime))) {
          alert('End time is after latest job end time, Please verify job entries')
          this.loading = false
          return
        }
        if (this.emp !== '' && this.company !== '') {
          this.postObj = {
            emp: this.empID,
            company: this.company,
            type: 'out',
            data: {
              end: end,
              nightOut: this.nightOut,
              gps: this.gps,
              notes: this.notes,
              bonus: this.bonus
            }
          }
          axios.post(this.url + `/tanda-service/saveShiftsForEmp.ajax.php`, this.postObj)
            .then(response => {
              if (response.data > 0) {
                this.loading = false
                this.completeDialog = true
                this.addNewClockOut(end)
                this.shiftID = response.data
              } else if (response.data === 'You Are Not Within A Suitable Location' || response.data === 'Invalid GPS format' || response.data === 'Invalid GPS coordinates') {
                alert(response.data)
                this.loading = false
              }
            })
            .catch(error => {
              console.log('subMitClock3')
              this.loading = false
              this.errorDialog = true
              console.log(error)
            })
        }
      }
    },
    addNewClockOut (end) {
      localStorage.removeItem('savedJobHistory')
      let timesheet = [...this.$store.getters.timesheet]
      for (let shift in timesheet) {
        if (typeof (timesheet[shift].end) === 'undefined') {
          timesheet[shift].end = end
          break
        }
      }

      dbPromise().then((db) => {
        let tx = db.transaction('timesheet-archive', 'readwrite')
        let timesheetStore = tx.objectStore('timesheet-archive')
        timesheetStore.put(timesheet, this.empID)
        return tx.complete
      }).then(() => {
        console.log('data saved locally')
      })
    },
    saveLocally (data) {
      dbPromise().then((db) => {
        let tx = db.transaction('outbox-timesheets', 'readwrite')
        let timesheetStore = tx.objectStore('outbox-timesheets')
        timesheetStore.put(data)
        return tx.complete
      }).then(() => {
        console.log('data saved locally')
      })
    },
    formatTimeStringToDate () {
      return moment(this.time, 'HH:mm').toDate()
    },
    formatTimeDateToString () {
      return moment(this.time).format('HH:mm')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ClockOutComponent.vue